export const MoveIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
      <g clipPath='url(#clip0_15792_11991)'>
        <path
          d='M3.33398 6.00065L1.33398 8.00065M1.33398 8.00065L3.33398 10.0007M1.33398 8.00065H14.6673M6.00065 3.33398L8.00065 1.33398M8.00065 1.33398L10.0007 3.33398M8.00065 1.33398V14.6673M10.0007 12.6673L8.00065 14.6673M8.00065 14.6673L6.00065 12.6673M12.6673 6.00065L14.6673 8.00065M14.6673 8.00065L12.6673 10.0007'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_15792_11991'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
